// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Category = require("../Control.Category/index.js");
var Data_Functor_Variant = require("../Data.Functor.Variant/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Formless_Types_Component = require("../Formless.Types.Component/index.js");
var Halogen_Data_Slot = require("../Halogen.Data.Slot/index.js");
var Halogen_Query = require("../Halogen.Query/index.js");
var Halogen_Query_ChildQuery = require("../Halogen.Query.ChildQuery/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var submitReply = (function () {
    var $8 = Data_Functor_Variant.inj()(new Data_Symbol.IsSymbol(function () {
        return "query";
    }))(Formless_Types_Component.functorQueryF)(Data_Symbol.SProxy.value);
    return function ($9) {
        return $8(Formless_Types_Component.SubmitReply.create($9));
    };
})();
var sendQuery = function (dictIsSymbol) {
    return function (dictIsSymbol1) {
        return function (dictCons) {
            return function (dictCons1) {
                return function (dictOrd) {
                    return function (dictOrd1) {
                        return function (ol) {
                            return function (os) {
                                return function (il) {
                                    return function (is) {
                                        return function (cq) {
                                            return Halogen_Query_HalogenM.query()(dictIsSymbol)(dictOrd)(ol)(os)(Data_Functor_Variant.inj()(new Data_Symbol.IsSymbol(function () {
                                                return "query";
                                            }))(Formless_Types_Component.functorQueryF)(Data_Symbol.SProxy.value)(Formless_Types_Component.SendQuery.create(Halogen_Query_ChildQuery.mkChildQueryBox(new Halogen_Query_ChildQuery.ChildQuery(function (dictApplicative) {
                                                return function (k) {
                                                    var $10 = Data_Maybe.maybe(Control_Applicative.pure(dictApplicative)(Data_Maybe.Nothing.value))(k);
                                                    var $11 = Halogen_Data_Slot.lookup()(dictIsSymbol1)(dictOrd1)(il)(is);
                                                    return function ($12) {
                                                        return $10($11($12));
                                                    };
                                                };
                                            }, cq, Control_Category.identity(Control_Category.categoryFn))))));
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var injQuery = function (dictFunctor) {
    return Data_Functor_Variant.inj()(new Data_Symbol.IsSymbol(function () {
        return "userQuery";
    }))(dictFunctor)(Data_Symbol.SProxy.value);
};
var asQuery = (function () {
    var $13 = Data_Functor_Variant.inj()(new Data_Symbol.IsSymbol(function () {
        return "query";
    }))(Formless_Types_Component.functorQueryF)(Data_Symbol.SProxy.value);
    return function ($14) {
        return $13(Halogen_Query.tell(Formless_Types_Component.AsQuery.create($14)));
    };
})();
module.exports = {
    injQuery: injQuery,
    asQuery: asQuery,
    submitReply: submitReply,
    sendQuery: sendQuery
};
